import type { DataOptions } from './types';
import { logXhrResponseCheck, xhrErrorLog } from './util';
import { error } from '@/util/console';

export default function send(
    { url, data, timeout }: DataOptions,
    callback?: (error?: any) => void,
): Promise<{
    error?: string;
    response?: string
}> {
    return new Promise(resolve => {
        if (typeof XMLHttpRequest === 'undefined') return;
        const xhr = new XMLHttpRequest();
        // async 同步情况会报错，而且影响性能，取消使用同步
        xhr.open('POST', url);
        xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
        if (typeof data === 'object' && !(data instanceof Uint8Array)) {
            data = JSON.stringify(data);
        }
        if (timeout) {
            xhr.timeout = timeout;
        }
        xhr.onload = () => {
            const err = logXhrResponseCheck(xhr.status, xhr.response, url, data);
            callback && callback(err);
            resolve({
                error: err,
                response: err ? undefined : xhr.response,
            });
        };

        xhr.ontimeout = xhr.onerror = err => {
            if (err) xhrErrorLog(err, url, data);
            // err 不能直接传入 postMessage，会导致 postMessage 直接报错，误认为 worker 内部直接逻辑报错，以后发送埋点直接无法压缩
            callback && callback(err ? 'networkTimeout' : '');
            resolve({
                error: 'networkTimeout',
            });
        };
        xhr.send(data);
        return xhr;
    });
}

export const get = (url: string) => {
    if (typeof XMLHttpRequest === 'undefined') return;
    const errorHandler = (err: any) => error('[error 401]', `GET 请求出错 url: ${url}`, err);
    try {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
        xhr.send();
        xhr.onerror = errorHandler;
    } catch (err) {
        errorHandler(err);
    }
};
